import styled from 'styled-components';

export const LayoutContainer = styled.div`
  width: 75%;
  margin: auto;
  @media (max-width: 767px) {
    width: 100%;
  }
`;
